export default function initGrillesDeCours() {
    const sessionsBtns = document.querySelectorAll('[data-change-session]');
    const sessionsZones = document.querySelectorAll('[data-zone]');
    const coursRowsBtns = document.querySelectorAll('[data-open-row]');

    if (!coursRowsBtns || !sessionsBtns) {
        return;
    }

    initTooltips();

    sessionsBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            sessionsBtns.forEach((btn) => {
                btn.classList.remove('is-active');
            });

            btn.classList.add('is-active');

            const btnId = btn.getAttribute('href');

            sessionsZones.forEach((zone) => {
                zone.classList.remove('is-active');

                if (zone.getAttribute('data-zone') === btnId) {
                    zone.classList.add('is-active');
                }
            });

            // Window push history state
            window.history.pushState(null, null, btnId);
        });
    });

    // hash
    const hash = window.location.hash;

    if (hash) {
        sessionsBtns.forEach((btn) => {
            if (btn.getAttribute('href') === hash) {
                btn.click();
            }
        });
    }

    coursRowsBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const row = btn.closest('[data-row]');

            if (!row) {
                return;
            }

            row.classList.toggle('is-active');
            btn.setAttribute('aria-expanded', row.classList.contains('is-active'));

            if (row.classList.contains('is-active')) {
                // all links should now be tabbable
                const links = row.querySelectorAll('a');
                links.forEach((link) => {
                    link.setAttribute('tabindex', 0);
                });
            } else {
                // all links should now be untabbable
                const links = row.querySelectorAll('a');
                links.forEach((link) => {
                    link.setAttribute('tabindex', -1);
                });
            }
        });
    });
}

function initTooltips() {
    const tooltips = document.querySelectorAll('[data-tooltip]');

    if (!tooltips) {
        return;
    }

    tooltips.forEach((tooltip) => {
        const parentLi = tooltip.closest('[data-row]')
            ? tooltip.closest('[data-row]')
            : tooltip.closest('[data-zone]');
        const tooltipOpen = tooltip.querySelector('[data-open-tooltip]');
        const tooltipContent = tooltip.querySelector('[data-tooltip-content]');

        const tooltipClose = tooltip.querySelectorAll('[data-close-tooltip]');

        if (!tooltipOpen || !tooltipContent) {
            return;
        }

        tooltipOpen.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const tooltipId = tooltipOpen.getAttribute('data-open-tooltip');
            const tooltipContentEl = document.querySelector(
                `[data-tooltip-content="${tooltipId}"]`
            );

            if (!tooltipContentEl) {
                return;
            }

            if (tooltipOpen.classList.contains('is-active')) {
                tooltip.classList.remove('is-active');
                parentLi.classList.remove('has-tooltip');
                tooltipOpen.classList.remove('is-active');
                tooltipContentEl.classList.remove('is-active');
                return;
            }

            // Close other tooltips
            tooltips.forEach((tooltip) => {
                const tooltipOpen = tooltip.querySelector('[data-open-tooltip]');
                const tooltipContent = tooltip.querySelector('[data-tooltip-content]');

                if (tooltipOpen && tooltipContent) {
                    tooltip.classList.remove('is-active');
                    parentLi.classList.remove('has-tooltip');
                    tooltipOpen.classList.remove('is-active');
                    tooltipContent.classList.remove('is-active');
                }
            });

            tooltip.classList.add('is-active');
            parentLi.classList.add('has-tooltip');
            tooltipOpen.classList.add('is-active');
            tooltipContentEl.classList.add('is-active');
        });

        tooltipClose.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                tooltip.classList.remove('is-active');
                parentLi.classList.remove('has-tooltip');
                tooltipOpen.classList.remove('is-active');
                tooltipContent.classList.remove('is-active');
            });
        });
    });
}
